import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { NewsLetterBoxInputContainer } from '../../../../../../../../../../../../../../../NewsletterBox/components/input/components';

export const ArticleNewsLetterBoxFirstNameInputContainer = (props: React.PropsWithChildren<{
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
}>) => {
  const {
    widthLines,
    children,
  } = props;
  return (
    <NewsLetterBoxInputContainer
      widthLines={widthLines}
      paddingLeft="none"
      paddingRight={1 / 8}
      paddingVertical={1 / 8}
    >
      {children}
    </NewsLetterBoxInputContainer>
  );
};
